<template>
  <div class="container-fluid" style="min-height: 100%;">
    <div class="row">
      <main class="col-md-12" style="background-color: #F7F7F8;">
        <div class="row justify-content-center" style="margin-top: 20px; margin-bottom: 100px;">
          <div class="col-12">

            <div class="text-center" style="margin-bottom: 10px;">
              <h3 style="color:#E5097F;">Historique des actions (annulations, suppressions, contrôle admin)</h3>
              <p style="color:#666; font-size: 14px;">
                Journal permanent, en lecture seule. Chaque annulation et chaque suppression y est
                inscrite&nbsp;: rien ne peut y être effacé ni modifié.
              </p>
            </div>

            <div class="text-center" style="margin-bottom: 12px;">
              <span class="badge" style="background:#fd7e14; margin: 0 4px;">Annulation</span>
              <span class="badge" style="background:#dc3545; margin: 0 4px;">Suppression</span>
              <span class="badge" style="background:#28a745; margin: 0 4px;">Réactivation</span>
              <button class="btn btn-sm btn-outline-secondary" style="margin-left: 12px;" @click="fetchLogs">Rafraîchir</button>
            </div>

            <div v-if="logs.length" class="table-responsive">
              <table class="table table-bordered table-hover" style="background:white; font-size: 13px;">
                <thead style="background:#E5097F; color:white;">
                  <tr>
                    <th>Date</th>
                    <th>Action</th>
                    <th>Course</th>
                    <th>Référence</th>
                    <th>Point relais</th>
                    <th>Expéditeur</th>
                    <th>Destinataire</th>
                    <th>Pays</th>
                    <th>Transporteur</th>
                    <th>Annulation transporteur</th>
                    <th>Prix</th>
                    <th>Auteur</th>
                    <th>Motif</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="log in logs" :key="log.id">
                    <td style="white-space: nowrap;">{{ log.created_at }}</td>
                    <td>
                      <span class="badge" :style="{ background: actionColor(log.action) }">{{ actionLabel(log.action) }}</span>
                    </td>
                    <td>#{{ log.shipment_id }}</td>
                    <td>{{ log.order_reference || log.tracking_number }}</td>
                    <td>{{ log.service_point_name }}</td>
                    <td>{{ log.sender_name }}</td>
                    <td>{{ log.recipient_name }}</td>
                    <td>{{ log.country }}</td>
                    <td>{{ log.transporter }}</td>
                    <td>{{ log.carrier_result }}</td>
                    <td style="white-space: nowrap;">{{ log.sale_price ? (log.sale_price + ' €') : '' }}</td>
                    <td>{{ log.performed_by }}</td>
                    <td>{{ log.reason }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="text-center" style="margin-top: 40px; color:#888;">
              Aucune annulation ni suppression enregistrée pour le moment.
            </div>

          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ActionHistory',
  data() {
    return {
      logs: [],
    }
  },
  mounted() {
    this.fetchLogs();
  },
  methods: {
    async fetchLogs() {
      this.$store.commit('setIsLoading', true)
      await axios
        .post('/api/v1/admin/get-action-logs/')
        .then(response => {
          this.logs = response.data.logs || [];
        })
        .catch(error => {
          console.log(JSON.stringify(error));
        })
      this.$store.commit('setIsLoading', false)
    },
    actionLabel(action) {
      if (action === 'CANCEL') return 'Annulation';
      if (action === 'DELETE') return 'Suppression';
      if (action === 'REACTIVATE') return 'Réactivation';
      if (action === 'ADMIN_EDIT') return 'Modification admin';
      if (action === 'ADMIN_BOOK') return 'Réservation transporteur (admin)';
      if (action === 'ADMIN_VALIDATE') return 'Validation admin';
      return action;
    },
    actionColor(action) {
      if (action === 'CANCEL') return '#fd7e14';
      if (action === 'DELETE') return '#dc3545';
      if (action === 'REACTIVATE') return '#28a745';
      if (action === 'ADMIN_EDIT') return '#0d6efd';
      if (action === 'ADMIN_BOOK') return '#6f42c1';
      if (action === 'ADMIN_VALIDATE') return '#198754';
      return '#6c757d';
    },
  },
}
</script>
